<template>
  <div>
    <el-select :value="value" value-key="id" :size="size" @input="change($event)" :clearable="true" :placeholder="$t('table.wechat')">
      <el-option label="----------" :value="emptyValue" />
      <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item" />
    </el-select>
    <el-button v-if="config && config.update" @click="handleUpdate" >{{ $t('table.update') }}</el-button>
  </div>
</template>

<script>

import { fetchWechatList } from '../api/wechat'
export default {
  data () {
    return {
      emptyValue: { id: 0 },
      options: []
    }
  },
  created () {
    fetchWechatList({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  props: ['value', 'config', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    },
    handleUpdate () {
      fetchWechatList({limit: 0}).then((res) => {
        this.options = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/WechatAppSelect.vue